import React from 'react';
import { Colors, hexToRGB } from '../../../../play-core/styles/Colors';
import { Label } from '../Label/Label';
import { jsx as _jsx } from "react/jsx-runtime";
export const InfoLabel = ({
  text,
  type = 'default',
  className
}) => /*#__PURE__*/_jsx(Label, {
  text: text,
  fontColor: fontColor[type],
  backgroundColor: backgroundColor[type],
  className: className
});
const backgroundColor = {
  default: Colors.RED_8b0019,
  expiringSoon: Colors.ORANGE_df5200,
  live: Colors.RED_d50000,
  comingSoon: hexToRGB(Colors.BLACK, 0.8)
};
const fontColor = {
  default: Colors.WHITE,
  expiringSoon: Colors.WHITE,
  live: Colors.WHITE,
  comingSoon: Colors.WHITE
};